import fomApi from '../../../services/fomApi';
export function load(){
    return async function(dispatch){
        const providerList = await fomApi.getProviderList();
        const action = { type : 'PROVIDER_INIT', payload : providerList}
        dispatch(action);
    }
}

